
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.EdlinkAccessTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  token: 'token',
  refreshToken: 'refreshToken',
  expiresIn: 'expiresIn',
  refreshedAt: 'refreshedAt',
  userId: 'userId'
};

exports.Prisma.EdlinkIntegrationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  integrationId: 'integrationId',
  providerName: 'providerName',
  organizationId: 'organizationId'
};

exports.Prisma.OrganizationEdlinkIntegrationIdSnapshotScalarFieldEnum = {
  organizationId: 'organizationId',
  edlinkIntegrationId: 'edlinkIntegrationId',
  capturedAt: 'capturedAt'
};

exports.Prisma.AppUserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  inactive: 'inactive',
  invitedAt: 'invitedAt',
  lastSignIn: 'lastSignIn',
  firstName: 'firstName',
  middleName: 'middleName',
  lastName: 'lastName',
  dateOfBirth: 'dateOfBirth',
  hasNoAddress: 'hasNoAddress',
  hasNoPhoneNumber: 'hasNoPhoneNumber',
  email: 'email',
  edlinkPersonId: 'edlinkPersonId',
  inactiveReason: 'inactiveReason',
  selectedOrganizationRoleId: 'selectedOrganizationRoleId',
  phoneNumberId: 'phoneNumberId',
  primaryEmailId: 'primaryEmailId'
};

exports.Prisma.AdminEmailChangeRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  subjectUserId: 'subjectUserId',
  creatorId: 'creatorId',
  oldEmail: 'oldEmail',
  newEmail: 'newEmail',
  reason: 'reason'
};

exports.Prisma.AdminUserStatusChangeRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  subjectUserId: 'subjectUserId',
  creatorId: 'creatorId',
  reason: 'reason',
  previousInactive: 'previousInactive',
  newInactive: 'newInactive'
};

exports.Prisma.AppUserEmailScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  verifiedAt: 'verifiedAt',
  email: 'email'
};

exports.Prisma.EmailToOrganizationScalarFieldEnum = {
  emailId: 'emailId',
  organizationId: 'organizationId'
};

exports.Prisma.EmailVerificationLinkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  emailId: 'emailId'
};

exports.Prisma.AppUserPhoneNumberScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  phoneNumber: 'phoneNumber',
  verifiedAt: 'verifiedAt'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  enterpriseIdpId: 'enterpriseIdpId',
  type: 'type',
  edlinkOnboardingId: 'edlinkOnboardingId',
  credentialIssuerId: 'credentialIssuerId'
};

exports.Prisma.OrganizationRoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  role: 'role',
  userId: 'userId',
  cleared: 'cleared',
  organizationId: 'organizationId'
};

exports.Prisma.OrganizationSupportContactScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  email: 'email',
  title: 'title',
  organizationId: 'organizationId'
};

exports.Prisma.CollaborativeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.CollaborativeSettingsScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enableActivitySubmittedNotifications: 'enableActivitySubmittedNotifications',
  enableActivityReturnedNotifications: 'enableActivityReturnedNotifications',
  collaborativeId: 'collaborativeId'
};

exports.Prisma.RegisteredApprenticeshipProgramScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayOrder: 'displayOrder',
  description: 'description',
  rapidsId: 'rapidsId',
  isPublished: 'isPublished',
  collaborativeId: 'collaborativeId',
  programId: 'programId'
};

exports.Prisma.AssignedRapScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  learnerId: 'learnerId',
  rapId: 'rapId',
  startDate: 'startDate',
  endDate: 'endDate'
};

exports.Prisma.RegisteredApprenticeshipProgramArtifactScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  type: 'type',
  registeredApprenticeshipProgramId: 'registeredApprenticeshipProgramId'
};

exports.Prisma.ProgramTimeItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  programId: 'programId',
  name: 'name',
  target: 'target'
};

exports.Prisma.OccupationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  code: 'code',
  name: 'name',
  searchIndexedName: 'searchIndexedName'
};

exports.Prisma.ProgramScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayOrder: 'displayOrder',
  description: 'description',
  levelLockSettingEnabled: 'levelLockSettingEnabled',
  absenceTrackingEnabled: 'absenceTrackingEnabled',
  courseworkEnabled: 'courseworkEnabled',
  observationsRequirePreapproval: 'observationsRequirePreapproval',
  state: 'state',
  organizationId: 'organizationId',
  registeredApprenticeshipProgramId: 'registeredApprenticeshipProgramId',
  externalId: 'externalId',
  timeSchedule: 'timeSchedule',
  observationScoringMethod: 'observationScoringMethod',
  observationTargetScore: 'observationTargetScore',
  observationCustomLabels: 'observationCustomLabels',
  occupationId: 'occupationId',
  industry: 'industry'
};

exports.Prisma.ProgramTimeEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  relatedUserId: 'relatedUserId',
  creatorId: 'creatorId',
  dateKey: 'dateKey',
  programId: 'programId'
};

exports.Prisma.ProgramTimeEntryItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  entryId: 'entryId',
  itemId: 'itemId',
  minutes: 'minutes'
};

exports.Prisma.ProgramTimeEntryReviewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  creatorId: 'creatorId',
  state: 'state',
  entryId: 'entryId',
  comment: 'comment'
};

exports.Prisma.AssignedProgramScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  learnerId: 'learnerId',
  programId: 'programId',
  startDate: 'startDate',
  anticipatedEndDate: 'anticipatedEndDate',
  status: 'status'
};

exports.Prisma.AssignedProgramHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  assignedProgramId: 'assignedProgramId',
  statusFrom: 'statusFrom',
  statusTo: 'statusTo',
  updatedById: 'updatedById'
};

exports.Prisma.LevelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayOrder: 'displayOrder',
  description: 'description',
  externalId: 'externalId',
  programId: 'programId'
};

exports.Prisma.AssignedLevelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  learnerId: 'learnerId',
  levelId: 'levelId',
  unlockOn: 'unlockOn',
  assignedProgramId: 'assignedProgramId'
};

exports.Prisma.PlanScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayOrder: 'displayOrder',
  description: 'description',
  joinCode: 'joinCode',
  externalId: 'externalId',
  levelId: 'levelId'
};

exports.Prisma.AssignedInstructorScalarFieldEnum = {
  createdAt: 'createdAt',
  instructorId: 'instructorId',
  planId: 'planId'
};

exports.Prisma.AssignedPlanScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  learnerId: 'learnerId',
  planId: 'planId',
  assignedLevelId: 'assignedLevelId'
};

exports.Prisma.ActivityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayOrder: 'displayOrder',
  description: 'description',
  externalId: 'externalId',
  planId: 'planId',
  rubricId: 'rubricId'
};

exports.Prisma.ActivityRequirementScalarFieldEnum = {
  requiredArtifact: 'requiredArtifact',
  requirementAppliesTo: 'requirementAppliesTo',
  activityId: 'activityId'
};

exports.Prisma.AssignedActivityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  learnerId: 'learnerId',
  activityId: 'activityId',
  status: 'status',
  assignedPlanId: 'assignedPlanId',
  startDate: 'startDate',
  dueDate: 'dueDate',
  timeSpentOnActivity: 'timeSpentOnActivity'
};

exports.Prisma.AssignedActivityLinkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  url: 'url',
  displayText: 'displayText',
  creatorId: 'creatorId',
  assignedActivityId: 'assignedActivityId',
  submissionId: 'submissionId'
};

exports.Prisma.ActivityLinkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  url: 'url',
  displayText: 'displayText',
  creatorId: 'creatorId',
  activityId: 'activityId'
};

exports.Prisma.AssignedActivityCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  comment: 'comment',
  creatorId: 'creatorId',
  assignedActivityId: 'assignedActivityId',
  submissionId: 'submissionId'
};

exports.Prisma.AssignedActivityObservationDateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  creatorId: 'creatorId',
  observedAt: 'observedAt',
  submissionId: 'submissionId',
  assignedActivityId: 'assignedActivityId'
};

exports.Prisma.AssignedActivityScoreScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  creatorId: 'creatorId',
  value: 'value',
  submissionId: 'submissionId',
  assignedActivityId: 'assignedActivityId'
};

exports.Prisma.AssignedActivityFileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  fileName: 'fileName',
  filePath: 'filePath',
  mimeType: 'mimeType',
  creatorId: 'creatorId',
  assignedActivityId: 'assignedActivityId',
  submissionId: 'submissionId'
};

exports.Prisma.ActivityFileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  fileName: 'fileName',
  filePath: 'filePath',
  mimeType: 'mimeType',
  creatorId: 'creatorId',
  activityId: 'activityId'
};

exports.Prisma.ProgramTimeEntryReviewToReviewerScalarFieldEnum = {
  programTimeEntryReviewId: 'programTimeEntryReviewId',
  reviewerId: 'reviewerId',
  assignedAt: 'assignedAt',
  assignedById: 'assignedById'
};

exports.Prisma.AssignedActivitySubmissionToReviewerScalarFieldEnum = {
  submissionId: 'submissionId',
  reviewerId: 'reviewerId',
  assignedAt: 'assignedAt',
  assignedById: 'assignedById'
};

exports.Prisma.AssignedActivitySubmissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  assignedActivityId: 'assignedActivityId',
  creatorId: 'creatorId',
  status: 'status'
};

exports.Prisma.AssignedEvaluatorScalarFieldEnum = {
  createdAt: 'createdAt',
  evaluatorId: 'evaluatorId',
  learnerId: 'learnerId'
};

exports.Prisma.UserTagScalarFieldEnum = {
  id: 'id',
  value: 'value',
  organizationId: 'organizationId'
};

exports.Prisma.UserTagMapScalarFieldEnum = {
  userId: 'userId',
  userTagId: 'userTagId'
};

exports.Prisma.ContentTagClusterScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  type: 'type'
};

exports.Prisma.ContentTagGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  tagClusterId: 'tagClusterId'
};

exports.Prisma.ContentTagToTagGroupScalarFieldEnum = {
  createdAt: 'createdAt',
  tagId: 'tagId',
  tagGroupId: 'tagGroupId'
};

exports.Prisma.ContentTagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  value: 'value',
  displayValue: 'displayValue',
  tagClusterId: 'tagClusterId'
};

exports.Prisma.RapTagClusterScalarFieldEnum = {
  createdAt: 'createdAt',
  tagClusterId: 'tagClusterId',
  rapId: 'rapId'
};

exports.Prisma.ActivityTagScalarFieldEnum = {
  createdAt: 'createdAt',
  tagId: 'tagId',
  activityId: 'activityId'
};

exports.Prisma.AppEventScalarFieldEnum = {
  id: 'id',
  eventType: 'eventType',
  collaborativeEnableActivityReturnedNotifications: 'collaborativeEnableActivityReturnedNotifications',
  collaborativeEnableActivitySubmittedNotifications: 'collaborativeEnableActivitySubmittedNotifications',
  collaborativeId: 'collaborativeId',
  collaborativeName: 'collaborativeName',
  organizationId: 'organizationId',
  organizationName: 'organizationName',
  organizationRoleId: 'organizationRoleId',
  organizationType: 'organizationType',
  role: 'role',
  createdAt: 'createdAt',
  userEmail: 'userEmail',
  userId: 'userId',
  eventDetail: 'eventDetail'
};

exports.Prisma.CredentialScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  externalIdentifier: 'externalIdentifier',
  provider: 'provider',
  name: 'name',
  description: 'description'
};

exports.Prisma.AssociatedCredentialScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  credentialId: 'credentialId',
  programId: 'programId',
  levelId: 'levelId',
  planId: 'planId',
  activityId: 'activityId'
};

exports.Prisma.CredentialLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  offerId: 'offerId',
  learnerId: 'learnerId',
  associatedCredentialId: 'associatedCredentialId'
};

exports.Prisma.SynchronousCredentialLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  status: 'status',
  issuerData: 'issuerData',
  learnerId: 'learnerId',
  associatedCredentialId: 'associatedCredentialId'
};

exports.Prisma.CredentialIssuerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  tenantDid: 'tenantDid',
  termsUrl: 'termsUrl',
  logoUrl: 'logoUrl',
  addToWalletUrl: 'addToWalletUrl',
  addressCountry: 'addressCountry',
  addressState: 'addressState'
};

exports.Prisma.RubricScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  externalId: 'externalId',
  numericRatingEnabled: 'numericRatingEnabled',
  naRatingEnabled: 'naRatingEnabled',
  state: 'state',
  organizationId: 'organizationId'
};

exports.Prisma.CriterionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  externalId: 'externalId',
  order: 'order',
  rubricId: 'rubricId'
};

exports.Prisma.CriterionTagScalarFieldEnum = {
  createdAt: 'createdAt',
  tagId: 'tagId',
  criterionId: 'criterionId'
};

exports.Prisma.RatingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  label: 'label',
  description: 'description',
  score: 'score',
  order: 'order',
  criterionId: 'criterionId'
};

exports.Prisma.ActivityReviewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  assignedActivityId: 'assignedActivityId',
  assignedActivitySubmissionId: 'assignedActivitySubmissionId',
  creatorId: 'creatorId',
  state: 'state'
};

exports.Prisma.TargetRatingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  criterionId: 'criterionId',
  activityId: 'activityId',
  direction: 'direction',
  ratingId: 'ratingId'
};

exports.Prisma.ScoredCriterionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  activityReviewId: 'activityReviewId',
  criterionId: 'criterionId',
  selectedRatingId: 'selectedRatingId',
  comment: 'comment'
};

exports.Prisma.UserExternalIdScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  value: 'value',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.SendGridEventScalarFieldEnum = {
  id: 'id',
  eventType: 'eventType',
  email: 'email',
  timestamp: 'timestamp',
  reason: 'reason',
  createdAt: 'createdAt',
  eventDetail: 'eventDetail'
};

exports.Prisma.UnreachableEmailScalarFieldEnum = {
  userId: 'userId',
  sendgridEventIds: 'sendgridEventIds'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  zipCode: 'zipCode',
  country: 'country'
};

exports.Prisma.UserAddressScalarFieldEnum = {
  userId: 'userId',
  addressId: 'addressId'
};

exports.Prisma.LearnerCohortToFacilitatorScalarFieldEnum = {
  createdAt: 'createdAt',
  learnerCohortId: 'learnerCohortId',
  facilitatorId: 'facilitatorId'
};

exports.Prisma.LearnerCohortToLearnerScalarFieldEnum = {
  createdAt: 'createdAt',
  learnerCohortId: 'learnerCohortId',
  learnerId: 'learnerId'
};

exports.Prisma.FavoritedLearnerCohortScalarFieldEnum = {
  createdAt: 'createdAt',
  learnerCohortId: 'learnerCohortId',
  userId: 'userId'
};

exports.Prisma.LearnerCohortScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  creatorId: 'creatorId',
  updaterId: 'updaterId',
  name: 'name',
  description: 'description',
  state: 'state',
  startDate: 'startDate',
  endDate: 'endDate',
  organizationId: 'organizationId'
};

exports.Prisma.MergeAccountRequestScalarFieldEnum = {
  id: 'id',
  userId1: 'userId1',
  userId2: 'userId2',
  email1: 'email1',
  email2: 'email2',
  source: 'source',
  refId: 'refId',
  confidenceScore: 'confidenceScore',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  token: 'token',
  authorizedUserId: 'authorizedUserId',
  changeSnapshot: 'changeSnapshot'
};

exports.Prisma.AbsenceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  appUserId: 'appUserId',
  programId: 'programId',
  date: 'date',
  duration: 'duration',
  reason: 'reason',
  comment: 'comment'
};

exports.Prisma.ObservationCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  programId: 'programId'
};

exports.Prisma.ObservationSkillScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  repeatable: 'repeatable',
  minimumSuccessfulAttempts: 'minimumSuccessfulAttempts',
  programId: 'programId',
  categoryId: 'categoryId'
};

exports.Prisma.ObservationCustomFieldScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  label: 'label',
  type: 'type',
  dropdownOptions: 'dropdownOptions',
  programId: 'programId'
};

exports.Prisma.ObservationAttemptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  scoredAt: 'scoredAt',
  performedAt: 'performedAt',
  learnerNotes: 'learnerNotes',
  skillId: 'skillId',
  learnerId: 'learnerId',
  observerId: 'observerId',
  score: 'score',
  observerComment: 'observerComment'
};

exports.Prisma.ObservationCustomFieldValueScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  value: 'value',
  attemptId: 'attemptId',
  customFieldId: 'customFieldId'
};

exports.Prisma.LearnerCohortToInstructorScalarFieldEnum = {
  createdAt: 'createdAt',
  learnerCohortId: 'learnerCohortId',
  instructorId: 'instructorId'
};

exports.Prisma.ObservationUnlockedSkillScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  learnerId: 'learnerId',
  skillId: 'skillId',
  unlockedById: 'unlockedById'
};

exports.Prisma.LearnerWageEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  rateUnit: 'rateUnit',
  effectiveDate: 'effectiveDate',
  entryDate: 'entryDate',
  reporter: 'reporter',
  reason: 'reason',
  learnerId: 'learnerId',
  employerId: 'employerId',
  programId: 'programId',
  reportedById: 'reportedById'
};

exports.Prisma.LearnerFundingEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  fundingSource: 'fundingSource',
  customFundingSource: 'customFundingSource',
  startDate: 'startDate',
  endDate: 'endDate',
  notes: 'notes',
  learnerId: 'learnerId',
  programId: 'programId',
  reportedById: 'reportedById'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.InactiveReason = exports.$Enums.InactiveReason = {
  INVALID_EMAIL: 'INVALID_EMAIL'
};

exports.OrganizationType = exports.$Enums.OrganizationType = {
  SPONSOR: 'SPONSOR',
  EDUCATION_PROVIDER: 'EDUCATION_PROVIDER',
  EMPLOYER: 'EMPLOYER',
  SYSTEM_ADMIN: 'SYSTEM_ADMIN'
};

exports.AppRole = exports.$Enums.AppRole = {
  LEARNER: 'LEARNER',
  EVALUATOR: 'EVALUATOR',
  ADMIN: 'ADMIN',
  INSTRUCTOR: 'INSTRUCTOR',
  OBSERVER: 'OBSERVER',
  FACILITATOR: 'FACILITATOR'
};

exports.RegisteredApprenticeshipProgramArtifactType = exports.$Enums.RegisteredApprenticeshipProgramArtifactType = {
  RAP_STANDARD: 'RAP_STANDARD',
  MEMORANDUM_OF_UNDERSTANDING: 'MEMORANDUM_OF_UNDERSTANDING'
};

exports.ProgramState = exports.$Enums.ProgramState = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED'
};

exports.TimeSchedule = exports.$Enums.TimeSchedule = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY'
};

exports.ObservationScoringMethod = exports.$Enums.ObservationScoringMethod = {
  PASS_FAIL: 'PASS_FAIL',
  SCALE_3: 'SCALE_3',
  SCALE_4: 'SCALE_4',
  SCALE_5: 'SCALE_5'
};

exports.Industry = exports.$Enums.Industry = {
  AGRICULTURE_FORESTRY_FISHING_HUNTING: 'AGRICULTURE_FORESTRY_FISHING_HUNTING',
  MINING: 'MINING',
  UTILITIES: 'UTILITIES',
  CONSTRUCTION: 'CONSTRUCTION',
  MANUFACTURING: 'MANUFACTURING',
  WHOLESALE_TRADE: 'WHOLESALE_TRADE',
  RETAIL_TRADE: 'RETAIL_TRADE',
  TRANSPORTATION_WAREHOUSING: 'TRANSPORTATION_WAREHOUSING',
  INFORMATION: 'INFORMATION',
  FINANCE_INSURANCE: 'FINANCE_INSURANCE',
  REAL_ESTATE_RENTAL_LEASING: 'REAL_ESTATE_RENTAL_LEASING',
  PROFESSIONAL_SCIENTIFIC_TECHNICAL_SERVICES: 'PROFESSIONAL_SCIENTIFIC_TECHNICAL_SERVICES',
  MANAGEMENT_OF_COMPANIES_ENTERPRISES: 'MANAGEMENT_OF_COMPANIES_ENTERPRISES',
  ADMINISTRATIVE_SUPPORT_WASTE_MANAGEMENT_REMEDIATION_SERVICES: 'ADMINISTRATIVE_SUPPORT_WASTE_MANAGEMENT_REMEDIATION_SERVICES',
  EDUCATIONAL_SERVICES: 'EDUCATIONAL_SERVICES',
  HEALTHCARE_SOCIAL_ASSISTANCE: 'HEALTHCARE_SOCIAL_ASSISTANCE',
  ARTS_ENTERTAINMENT_RECREATION: 'ARTS_ENTERTAINMENT_RECREATION',
  ACCOMMODATION_FOOD_SERVICES: 'ACCOMMODATION_FOOD_SERVICES',
  OTHER_SERVICES_EXCEPT_PUBLIC_ADMINISTRATION: 'OTHER_SERVICES_EXCEPT_PUBLIC_ADMINISTRATION',
  PUBLIC_ADMINISTRATION: 'PUBLIC_ADMINISTRATION'
};

exports.TimeEntryReviewState = exports.$Enums.TimeEntryReviewState = {
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  RETURNED: 'RETURNED'
};

exports.AssignedProgramStatus = exports.$Enums.AssignedProgramStatus = {
  ACTIVE: 'ACTIVE',
  ASSIGNED: 'ASSIGNED',
  COMPLETED: 'COMPLETED',
  WITHDRAWN: 'WITHDRAWN'
};

exports.RequiredActivityArtifact = exports.$Enums.RequiredActivityArtifact = {
  FILE_OR_LINK: 'FILE_OR_LINK',
  FILE: 'FILE',
  LINK: 'LINK',
  COMMENT: 'COMMENT',
  DURATION: 'DURATION',
  SCORE: 'SCORE',
  OBSERVATION_DATE: 'OBSERVATION_DATE'
};

exports.RequirementAppliesTo = exports.$Enums.RequirementAppliesTo = {
  LEARNER: 'LEARNER',
  EVALUATING_USER: 'EVALUATING_USER'
};

exports.ActivityStatus = exports.$Enums.ActivityStatus = {
  APPROVED: 'APPROVED',
  RETURNED: 'RETURNED',
  SUBMITTED: 'SUBMITTED',
  UNSUBMITTED: 'UNSUBMITTED'
};

exports.ContentTagType = exports.$Enums.ContentTagType = {
  GENERAL: 'GENERAL',
  COMPETENCY: 'COMPETENCY'
};

exports.CredentialProvider = exports.$Enums.CredentialProvider = {
  CREDENTIAL_ENGINE: 'CREDENTIAL_ENGINE',
  MAP_MY_FUTURE: 'MAP_MY_FUTURE'
};

exports.CredentialStatus = exports.$Enums.CredentialStatus = {
  FAILED: 'FAILED',
  EARNED: 'EARNED',
  OFFERED: 'OFFERED',
  ISSUED: 'ISSUED'
};

exports.SynchronousCredentialStatus = exports.$Enums.SynchronousCredentialStatus = {
  EARNED: 'EARNED',
  ERROR: 'ERROR',
  APPROVED: 'APPROVED'
};

exports.CredentialIssuerName = exports.$Enums.CredentialIssuerName = {
  VELOCITY: 'VELOCITY',
  MAP_MY_FUTURE: 'MAP_MY_FUTURE'
};

exports.RubricState = exports.$Enums.RubricState = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
};

exports.ActivityReviewState = exports.$Enums.ActivityReviewState = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED'
};

exports.TargetRatingDirection = exports.$Enums.TargetRatingDirection = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
};

exports.LearnerCohortState = exports.$Enums.LearnerCohortState = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED'
};

exports.MergeAccountRequestStatus = exports.$Enums.MergeAccountRequestStatus = {
  OPENED: 'OPENED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  PROCESSING: 'PROCESSING',
  COMMITTED: 'COMMITTED',
  ROLLBACK: 'ROLLBACK'
};

exports.AbsenceDuration = exports.$Enums.AbsenceDuration = {
  HALF_DAY_AM: 'HALF_DAY_AM',
  HALF_DAY_PM: 'HALF_DAY_PM',
  FULL_DAY: 'FULL_DAY'
};

exports.AbsenceReason = exports.$Enums.AbsenceReason = {
  PERSONAL_ILLNESS: 'PERSONAL_ILLNESS',
  PERSONAL_BUSINESS: 'PERSONAL_BUSINESS',
  PERSONAL_EMERGENCY: 'PERSONAL_EMERGENCY',
  FAMILY_ILLNESS: 'FAMILY_ILLNESS',
  CONFERENCE_WORKSHOP: 'CONFERENCE_WORKSHOP',
  BEREAVEMENT: 'BEREAVEMENT',
  JURY_DUTY: 'JURY_DUTY',
  OTHER: 'OTHER'
};

exports.ObservationCustomFieldType = exports.$Enums.ObservationCustomFieldType = {
  DROPDOWN: 'DROPDOWN'
};

exports.ObservationAttemptScore = exports.$Enums.ObservationAttemptScore = {
  COMPETENT: 'COMPETENT',
  NOT_COMPETENT: 'NOT_COMPETENT',
  SCORE_1: 'SCORE_1',
  SCORE_2: 'SCORE_2',
  SCORE_3: 'SCORE_3',
  SCORE_4: 'SCORE_4',
  SCORE_5: 'SCORE_5'
};

exports.WageRateUnit = exports.$Enums.WageRateUnit = {
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  YEARLY: 'YEARLY'
};

exports.WageReporter = exports.$Enums.WageReporter = {
  LEARNER: 'LEARNER',
  ADMIN: 'ADMIN'
};

exports.FundingSource = exports.$Enums.FundingSource = {
  WIOA: 'WIOA',
  PELL: 'PELL',
  PERKINS: 'PERKINS',
  ABA: 'ABA',
  SAEF: 'SAEF',
  H1B_TRAINING_GRANT: 'H1B_TRAINING_GRANT',
  OTHER: 'OTHER'
};

exports.Prisma.ModelName = {
  EdlinkAccessToken: 'EdlinkAccessToken',
  EdlinkIntegration: 'EdlinkIntegration',
  OrganizationEdlinkIntegrationIdSnapshot: 'OrganizationEdlinkIntegrationIdSnapshot',
  AppUser: 'AppUser',
  AdminEmailChangeRecord: 'AdminEmailChangeRecord',
  AdminUserStatusChangeRecord: 'AdminUserStatusChangeRecord',
  AppUserEmail: 'AppUserEmail',
  EmailToOrganization: 'EmailToOrganization',
  EmailVerificationLink: 'EmailVerificationLink',
  AppUserPhoneNumber: 'AppUserPhoneNumber',
  Organization: 'Organization',
  OrganizationRole: 'OrganizationRole',
  OrganizationSupportContact: 'OrganizationSupportContact',
  Collaborative: 'Collaborative',
  CollaborativeSettings: 'CollaborativeSettings',
  RegisteredApprenticeshipProgram: 'RegisteredApprenticeshipProgram',
  AssignedRap: 'AssignedRap',
  RegisteredApprenticeshipProgramArtifact: 'RegisteredApprenticeshipProgramArtifact',
  ProgramTimeItem: 'ProgramTimeItem',
  Occupation: 'Occupation',
  Program: 'Program',
  ProgramTimeEntry: 'ProgramTimeEntry',
  ProgramTimeEntryItem: 'ProgramTimeEntryItem',
  ProgramTimeEntryReview: 'ProgramTimeEntryReview',
  AssignedProgram: 'AssignedProgram',
  AssignedProgramHistory: 'AssignedProgramHistory',
  Level: 'Level',
  AssignedLevel: 'AssignedLevel',
  Plan: 'Plan',
  AssignedInstructor: 'AssignedInstructor',
  AssignedPlan: 'AssignedPlan',
  Activity: 'Activity',
  ActivityRequirement: 'ActivityRequirement',
  AssignedActivity: 'AssignedActivity',
  AssignedActivityLink: 'AssignedActivityLink',
  ActivityLink: 'ActivityLink',
  AssignedActivityComment: 'AssignedActivityComment',
  AssignedActivityObservationDate: 'AssignedActivityObservationDate',
  AssignedActivityScore: 'AssignedActivityScore',
  AssignedActivityFile: 'AssignedActivityFile',
  ActivityFile: 'ActivityFile',
  ProgramTimeEntryReviewToReviewer: 'ProgramTimeEntryReviewToReviewer',
  AssignedActivitySubmissionToReviewer: 'AssignedActivitySubmissionToReviewer',
  AssignedActivitySubmission: 'AssignedActivitySubmission',
  AssignedEvaluator: 'AssignedEvaluator',
  UserTag: 'UserTag',
  UserTagMap: 'UserTagMap',
  ContentTagCluster: 'ContentTagCluster',
  ContentTagGroup: 'ContentTagGroup',
  ContentTagToTagGroup: 'ContentTagToTagGroup',
  ContentTag: 'ContentTag',
  RapTagCluster: 'RapTagCluster',
  ActivityTag: 'ActivityTag',
  AppEvent: 'AppEvent',
  Credential: 'Credential',
  AssociatedCredential: 'AssociatedCredential',
  CredentialLog: 'CredentialLog',
  SynchronousCredentialLog: 'SynchronousCredentialLog',
  CredentialIssuer: 'CredentialIssuer',
  Rubric: 'Rubric',
  Criterion: 'Criterion',
  CriterionTag: 'CriterionTag',
  Rating: 'Rating',
  ActivityReview: 'ActivityReview',
  TargetRating: 'TargetRating',
  ScoredCriterion: 'ScoredCriterion',
  UserExternalId: 'UserExternalId',
  SendGridEvent: 'SendGridEvent',
  UnreachableEmail: 'UnreachableEmail',
  Address: 'Address',
  UserAddress: 'UserAddress',
  LearnerCohortToFacilitator: 'LearnerCohortToFacilitator',
  LearnerCohortToLearner: 'LearnerCohortToLearner',
  FavoritedLearnerCohort: 'FavoritedLearnerCohort',
  LearnerCohort: 'LearnerCohort',
  MergeAccountRequest: 'MergeAccountRequest',
  Absence: 'Absence',
  ObservationCategory: 'ObservationCategory',
  ObservationSkill: 'ObservationSkill',
  ObservationCustomField: 'ObservationCustomField',
  ObservationAttempt: 'ObservationAttempt',
  ObservationCustomFieldValue: 'ObservationCustomFieldValue',
  LearnerCohortToInstructor: 'LearnerCohortToInstructor',
  ObservationUnlockedSkill: 'ObservationUnlockedSkill',
  LearnerWageEntry: 'LearnerWageEntry',
  LearnerFundingEntry: 'LearnerFundingEntry'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
